'use strict';
import $ from 'jquery';

export default function(selector) {

	$(selector).each(function () {

		const $wrapper = $(this);
		const $input = $wrapper.find('input');
		const min = parseFloat($input.prop('min') || -Infinity);
		const max = parseFloat($input.prop('max') || Infinity);
		const step = parseFloat($input.prop('step') || 1);

		if ($wrapper.hasClass('enable-arrows')) {
      
			const $more = $('<div class="stepper stepper-more"><i class="is-icon is-icon-arrow"></i></div>');
			const $less = $('<div class="stepper stepper-less"><i class="is-icon is-icon-arrow"></i></div>');
			$wrapper.append($more, $less);

			$more.on('click', () => {
				$input.val(Math.min(max, parseFloat($input.val() || min) + step));
				$input.trigger('input').trigger('change');
			});

			$less.on('click', () => {
				$input.val(Math.max(min, parseFloat($input.val() || max) - step));
				$input.trigger('input').trigger('change');
			});

		}
	});

}
